import {useEffect, useState} from "react";
import {obtenerParametrosUrl} from "../Funciones/obtenerParametrosUrl";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {obtenerObjLocal} from "../../Servicios/Local/obtenerObjLocal";
import {guardarObjLocal} from "../../Servicios/Local/guardarObjLocal";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Funnel from "../../Pagina/Dialogos/Dialogo_Funnel";

export const usePasoActual = ({setTermino}) => {
    const irSiguientePaso = () => {


        let id = obtenerParametrosUrl({clave: 'id'})
        let pasoDoc = obtenerObjLocal({key: 'paso' + id})
        let funnelLocal = obtenerObjLocal({key: id})
        if (funnelLocal) {
            let paso = 0
            paso = pasoDoc && pasoDoc.paso ? pasoDoc.paso : 0
            if (paso >= 3) {
                paso = 3
            } else {
                paso++
            }

            colocarPasoActual(funnelLocal, paso)
            guardarObjLocal({key: 'paso' + id, obj: {paso: paso}})
        } else {

        }

        setTimeout(() => {
            window.scrollBy({
                top: 0,       // Píxeles a bajar (usa números negativos para subir)
                left: 0,        // Píxeles a mover horizontalmente
                behavior: 'smooth' // Activa la animación suave
            });
            setTermino(false)
        }, 500)


    }
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Funnel, realizado: irSiguientePaso})
    const [actual, setActual] = useState({});
    const [idUsuario, setIdUsuario] = useState('N/A');

    const siguiente = () => {


        if (actual && actual.formularioSi) {
            abrir(actual)
        } else {
            irSiguientePaso()
        }


    }


    const colocarPasoActual = (funnel, paso = 0) => {


        let obj = escogerPaso(funnel, paso)


        obj.idUsuario = obtenerParametrosUrl({clave: 'idUsu'})
        obj.idFunnel = obtenerParametrosUrl({clave: 'id'})
        obj.nombre = funnel.nombre
        obj.img = funnel.img
        obj.listaFrases = funnel.listaFrases
        obj.tituloIndicadores = funnel.tituloIndicadores
        obj.rosadotituloIndicadores = funnel.rosadotituloIndicadores
        obj.indicadores = funnel.indicadores
        obj.tituloAntes = funnel.tituloAntes
        obj.listaAntes = funnel.listaAntes
        obj.tituloDespues = funnel.tituloDespues
        obj.listaDespues = funnel.listaDespues
        obj.tituloPasos = funnel.tituloPasos
        obj.rosadoTituloPasos = funnel.rosadoTituloPasos
        obj.pasos = funnel.pasos
        obj.tituloTestimonios = funnel.tituloTestimonios
        obj.rosadoTituloTestimonios = funnel.rosadoTituloTestimonios
        obj.parrafoTestimonios = funnel.parrafoTestimonios
        obj.parrafoPreguntas = funnel.parrafoPreguntas
        obj.preguntas = funnel.preguntas
        obj.tituloFin = funnel.tituloFin
        obj.rosadoTituloFin = funnel.rosadoTituloFin
        obj.parrafoFin = funnel.parrafoFin
        setActual(obj)

    }

    const escogerPaso = (funnel, paso) => {


        let obj = {}

        switch (paso) {

            case 0:
                obj.video = funnel.videoUno
                obj.titulo = funnel.tituloUno
                obj.resaltado = funnel.tituloResaltadoUno
                obj.tituloParrafo = funnel.tituloParrafoUno
                obj.rosadoTitulo = funnel.rosadoTituloParrafoUno
                obj.blancoTitulo = funnel.blancoTituloParrafoUno
                obj.celesteTitulo = funnel.celesteTituloParrafoUno
                obj.parrafo = funnel.parrafoUno
                obj.numero = 1
                obj.tiempo = funnel.tiempoUno
                //
                obj.formularioSi = funnel.formularioSiUno
                obj.tituloFormulario = funnel.tituloFormularioUno
                obj.rosadoTituloFormulario = funnel.rosadoTituloFormularioUno
                obj.parrafoFormulario = funnel.parrafoFormularioUno
                obj.datosFormulario = funnel.datosUno
                break
            case 1:
                obj.video = funnel.videoDos
                obj.titulo = funnel.tituloDos
                obj.resaltado = funnel.tituloResaltadoDos
                obj.tituloParrafo = funnel.tituloParrafoDos
                obj.rosadoTitulo = funnel.rosadoTituloParrafoDos
                obj.blancoTitulo = funnel.blancoTituloParrafoDos
                obj.celesteTitulo = funnel.celesteTituloParrafoDos
                obj.parrafo = funnel.parrafoDos
                obj.numero = 2
                obj.tiempo = funnel.tiempoDos
                //
                obj.formularioSi = funnel.formularioSiDos
                obj.tituloFormulario = funnel.tituloFormularioDos
                obj.rosadoTituloFormulario = funnel.rosadoTituloFormularioDos
                obj.parrafoFormulario = funnel.parrafoFormularioDos
                obj.datosFormulario = funnel.datosDos
                break
            case 2:
                obj.video = funnel.videoTres
                obj.titulo = funnel.tituloTres
                obj.resaltado = funnel.tituloResaltadoTres
                obj.tituloParrafo = funnel.tituloParrafoTres
                obj.rosadoTitulo = funnel.rosadoTituloParrafoTres
                obj.blancoTitulo = funnel.blancoTituloParrafoTres
                obj.celesteTitulo = funnel.celesteTituloParrafoTres
                obj.parrafo = funnel.parrafoTres
                obj.numero = 3
                obj.tiempo = funnel.tiempoTres
                //
                obj.formularioSi = funnel.formularioSiTres
                obj.tituloFormulario = funnel.tituloFormularioTres
                obj.rosadoTituloFormulario = funnel.rosadoTituloFormularioTres
                obj.parrafoFormulario = funnel.parrafoFormularioTres
                obj.datosFormulario = funnel.datosTres
                break
            case 4:
            case 3:
                obj.video = funnel.videoTres
                obj.titulo = funnel.tituloTres
                obj.resaltado = funnel.tituloResaltadoTres
                obj.tituloParrafo = funnel.tituloParrafoTres
                obj.rosadoTitulo = funnel.rosadoTituloParrafoTres
                obj.blancoTitulo = funnel.blancoTituloParrafoTres
                obj.celesteTitulo = funnel.celesteTituloParrafoTres
                obj.parrafo = funnel.parrafoTres
                obj.numero = 3
                //
                obj.formularioSi = funnel.formularioSiTres
                obj.tituloFormulario = funnel.tituloFormularioTres
                obj.rosadoTituloFormulario = funnel.rosadoTituloFormularioTres
                obj.parrafoFormulario = funnel.parrafoFormularioTres
                obj.datosFormulario = funnel.datosTres
                break
            default:
                obj.video = funnel.videoUno
                obj.titulo = funnel.tituloUno
                obj.resaltado = funnel.tituloResaltadoUno
                obj.tituloParrafo = funnel.tituloParrafoUno
                obj.rosadoTitulo = funnel.rosadoTituloParrafoUno
                obj.blancoTitulo = funnel.blancoTituloParrafoUno
                obj.celesteTitulo = funnel.celesteTituloParrafoUno
                obj.parrafo = funnel.parrafoUno
                obj.tiempo = funnel.tiempoUno
                obj.numero = 1
                //
                obj.formularioSi = funnel.formularioSiUno
                obj.tituloFormulario = funnel.tituloFormularioUno
                obj.rosadoTituloFormulario = funnel.rosadoTituloFormularioUno
                obj.parrafoFormulario = funnel.parrafoFormularioUno
                obj.datosFormulario = funnel.datosUno
        }

        // console.log('inserta', obj)

        return obj

    }


    useEffect(() => {

        let id = obtenerParametrosUrl({clave: 'id'})

        let idUsuario = obtenerParametrosUrl({clave: 'idUsu'})
        setIdUsuario(idUsuario)


        let funnelLocal = obtenerObjLocal({key: id})

        if (funnelLocal) {
            let pasoDoc = obtenerObjLocal({key: 'paso' + id})
            let paso = 0
            paso = pasoDoc && pasoDoc.paso ? pasoDoc.paso : 0
            colocarPasoActual(funnelLocal, paso)
        } else {

            let w = [where('id', '==', id)]

            if (id) {
                //obtener campaña
                //guardamoslocal campaña

                let w2 = [where('idUsuario', '==', idUsuario), where('idFunnel', '==', id)]
                obtenerColWheres({col: 'campanas', wheres: w2}).then((dox) =>{
                    if (dox.data && dox.data[0]){
                        guardarObjLocal({key: 'campana', obj: dox.data[0]})
                    }
                })

                obtenerColWheres({col: 'funnels', wheres: w}).then((dox) => {
                    if (dox.res && dox.data[0]) {
                        guardarObjLocal({key: id, obj: dox.data[0]})
                        colocarPasoActual(dox.data[0])
                    }
                })
            } else {
                //Pagina 404
            }

        }


    }, [])
    return {
        actual,
        siguiente,
        idUsuario,
        Dialogo
    }
}